module.exports = __webpack_public_path__ + "img/full5-min.544f2cc7.png";